import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindBrandDocumentContent($signAdvantageFilter: String!,$brandAdvantageFilter: String!, $cornerFilter: String!)
{
  cmsSignData: queryEnseigneContents(top: 1, skip: 0, filter: $signAdvantageFilter) {
    data {
      pageTitle {
        iv
      }
      advantageTitle {
        iv
      }
      advantage {
        iv
      }
      mention: avantageMention {
        iv
      }
      mentionFontSize: avantageMentionFontSize {
        iv
      }
      mentionTextColor: avantageMentionTextColor {
        iv
      }
      logo {
        iv {
          url
          fileSize
        }
      }
      url {
        iv
      } 
    }
  }
  cmsBrandData: queryMarqueContents(top: 1, skip: 0, filter: $brandAdvantageFilter) {
    data {
      advantageTitle {
        iv
      }
      advantage {
        iv
      }
      url {
        iv
      }
      logo {
        iv {
          url
          fileSize
        }
      }
      mention {
        iv
      }
      mentionFontSize {
        iv
      }
      mentionTextColor {
        iv
      }
    }
  }
  cmsBrandCorner: queryCornerMarqueContents(top: 1, skip: 0, filter: $cornerFilter) {
    data {
      signId {
        iv
      }
      titleBlocTitle {
        iv
      }
      titleBlocSubTitle {
        iv
      }
      titleBlocFontSizeTitle {
        iv
      }
      titleBlocFontSizeSubTitle {
        iv
      }
      titleBlocTagline {
        iv
      }
      titleBlocTextColor {
        iv
      }
      titleBlocColor {
        iv
      }
      titleBlocCtaLink {
        iv
      }
      titleBlocCtaText {
        iv
      }
      titleBlocCtaStyle {
        iv
      }
      titleBlocCtaLink2 {
        iv
      }
      titleBlocCtaText2 {
        iv
      }
      titleBlocCtaStyle2 {
        iv
      }
      titleBlocPicture {
        iv {
          url
          fileSize
        }
      }
      titleBlocHorizontalPosition {
        iv
      }
      titleBlocJustification {
        iv
      }
      picture {
        iv {
          url
          fileSize
        }
      }
      link {
        iv
      }
      mention: mentionLabel {
        iv
      }
    }
  }
}
`,
]);
